import React from "react";
import homeMart from "../../Assets/projects/homeMart.jpg";
import royFashion from "../../Assets/projects/royFashion.jpg";
import glamorous from "../../Assets/projects/glamourous.jpg";
import auroraHealth from "../../Assets/projects/auroraHealth.jpg";
import boipoka from "../../Assets/projects/boipoka.jpg";

const Projects = () => {
  return (
    <section id="projects">
      <div className="container mx-auto">
        <h1 className="text-center text-5xl text-white text-accent font-serif font-bold my-9">MY PROJECTS</h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 lg:gap-5">
          <div class="max-w-sm rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
            <a href="#">
              <img class="rounded-t-lg" src={homeMart} alt="" />
            </a>
            <div class="p-5">
              <a href="#">
                <h5 class="mb-2 text-2xl font-bold tracking-tight text-white dark:text-white">
                  Home Mart
                </h5>
              </a>
              <p class="mb-3 font-normal text-white dark:text-gray-400">
                A Tools Manufacturer Website, Can manage, purchase tools
              </p>
              <a href="https://home-mart-b85e8.web.app/">
                <button class="btn btn-primary mr-2">Live Site</button>
              </a>
              <a href="https://github.com/alneedrs2/home-mart-client">
                <button class="btn btn-primary mr-2">Client Side</button>
              </a>
              <a href="https://github.com/alneedrs2/home-mart-server-side">
                <button class="btn btn-primary">Server Side</button>
              </a>
            </div>
          </div>
          <div class="max-w-sm rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
            <a href="#">
              <img class="rounded-t-lg" src={royFashion} alt="" />
            </a>
            <div class="p-5">
              <a href="#">
                <h5 class="mb-2 text-2xl font-bold tracking-tight text-white dark:text-white">
                  Roy & Fashions
                </h5>
              </a>
              <p class="mb-3 font-normal text-white 
              dark:text-gray-400">
                A Shopping Warehouse Website, Can manage products
              </p>
              <a href="https://assignment-eleven-9deb6.web.app/">
                <button class="btn btn-primary mr-3">Live Site</button>
              </a>
              <a href="https://github.com/alneedrs2/roy-fashion-client-side">
                <button class="btn btn-primary mr-2">Client Side</button>
              </a>
              <a href="https://github.com/alneedrs2/roy-fashion-server-side">
                <button class="btn btn-primary">Server Side</button>
              </a>
            </div>
          </div>
          <div class="max-w-sm rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
            <a href="#">
              <img class="rounded-t-lg" src={auroraHealth} alt="" />
            </a>
            <div class="p-5">
              <a href="#">
                <h5 class="mb-2 text-2xl font-bold tracking-tight text-white dark:text-white">
                  Aurora Health
                </h5>
              </a>
              <p class="mb-3 font-normal text-white dark:text-gray-400">
                A Personal Health Advisor Website, Can know about his/her and
                his/her sessions
              </p>
              <div>
                <a href="https://assignment-ten-d4be8.web.app/">
                  <button class="btn btn-primary">Live Site</button>
                </a>
                <a href="https://github.com/alneedrs2/aurora-health">
                  <button class="btn btn-primary ml-3">Client Side</button>
                </a>
              </div>
            </div>
          </div>
          <div class="max-w-sm rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
            <a href="#">
              <img class="rounded-t-lg" src={glamorous} alt="" />
            </a>
            <div class="p-5">
              <a href="#">
                <h5 class="mb-2 text-2xl font-bold tracking-tight text-white dark:text-white">
                  Glamourous
                </h5>
              </a>
              <p class="mb-3 font-normal text-white dark:text-gray-400">
                A Cosmetics Website with some special effects and features
              </p>
              <div>
                <a href="https://glamorous-beauty-shop.netlify.app/">
                  <button class="btn btn-primary">Live Site</button>
                </a>
                <a href="https://github.com/alneedrs2/product-analysis-glamourous">
                  <button class="btn btn-primary ml-3">Client Side</button>
                </a>
              </div>
            </div>
          </div>
          <div class="max-w-sm rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
            <a href="#">
              <img class="rounded-t-lg" src={boipoka} alt="" />
            </a>
            <div class="p-5">
              <a href="#">
                <h5 class="mb-2 text-2xl font-bold tracking-tight text-white dark:text-white">
                  Boi Poka
                </h5>
              </a>
              <p class="mb-3 font-normal text-white dark:text-gray-400">
                A book buying website, here also you can choose some book which
                is recomended
              </p>
              <div>
                <a href="https://boi-poka-assignment.netlify.app/">
                  <button class="btn btn-primary">Live Site</button>
                </a>
                <a href="https://github.com/alneedrs2/lucky-one-boipoka">
                  <button class="btn btn-primary ml-3">Client Side</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
